// src/components/ui/Logo/index.tsx
// Wordmark "MenuChef" portado 1:1 de menuchef-prototype/components.jsx (Logo).
// Estilos inline porque todas as medidas derivam de `size`.
import React from "react";

interface LogoProps {
  size?: number;
  light?: boolean;
  /** Quando fornecido, o wordmark vira um botão (ex.: voltar ao cardápio). */
  onClick?: () => void;
}

export default function Logo({ size = 30, light = false, onClick }: LogoProps) {
  const onColor = light ? "#fff" : "#0E7A66";
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      aria-label={onClick ? "Voltar ao início" : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 900,
        fontSize: size,
        lineHeight: 1,
        letterSpacing: -0.5,
        flexShrink: 0,
        cursor: onClick ? "pointer" : undefined,
      }}
    >
      <span style={{ color: onColor }}>Menu</span>
      <span
        style={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(150deg,#2ED38B,#16B877)",
          color: "#fff",
          borderRadius: size * 0.42,
          padding: `${size * 0.06}px ${size * 0.26}px ${size * 0.1}px`,
          boxShadow: "0 4px 12px rgba(31,184,119,0.35)",
        }}
      >
        {/* chapéu de chef simplificado */}
        <svg
          width={size * 0.62}
          height={size * 0.46}
          viewBox="0 0 28 20"
          fill="#fff"
          style={{
            position: "absolute",
            top: -size * 0.36,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <path d="M6 19h16v-4.2c2.4-.3 4-2.1 4-4.4 0-2.6-2.2-4.6-5-4.6-.3 0-.6 0-.9.1C19.4 3 17 1.3 14 1.3S8.6 3 7.9 5.9c-.3-.1-.6-.1-.9-.1-2.8 0-5 2-5 4.6 0 2.3 1.6 4.1 4 4.4V19Z" />
        </svg>
        Chef
      </span>
    </div>
  );
}
